import { localeNumberWithFixed } from "psims/lib/formatters/numbers";
import { StorageValidationResult } from "./enforceable-arrangements-validation";

export function getStorageInlineMessage(validationResult: StorageValidationResult | null): string | undefined {
  if (validationResult == null) {
    return undefined;
  }

  switch (validationResult.code) {
    case 'invalid_required':
      return 'A value is required for this field';
    case 'character_limit':
      return `Must be ${localeNumberWithFixed(validationResult.limit)} characters or fewer`;
    case 'invalid_volume':
      return 'Please enter a positive integer (zero is permitted) with a maximum of 1,000,000';  
    case 'invalid_end_date':
      return 'Agreement end date must be greater that Agreement start date';    
    case 'invalid_start_date_after_obligation':
      return 'Agreement start date must be on or before the Obligation date';
    case 'invalid_end_date_before_obligation':
      return 'Agreement end date must be on or after the Obligation date';  
  }
}
